import {BaseError, Links, Meta} from "./apiTypes";
import {TagProps} from 'antd';

export interface StaffManagementError extends BaseError {}

export type AssignableStaffRoles =
    'staff.business-development' |
    'staff.finance' |
    'staff.fleet' |
    'staff.human-resources' |
    'staff.marketing' |
    'staff.member-care';

export interface StaffProfile {
    id: number;
    user_id: number;
    first_name: string;
    last_name: string;
    email: string;
    roles: AssignableStaffRoles[];
    active: boolean;
    verified: boolean;
}

export interface StaffProfilesResponse {
    data: StaffProfile[];
    links: Links;
    meta: Meta;
}

export interface StaffProfileCreateParams {
    first_name: string;
    last_name: string;
    email: string;
    roles: AssignableStaffRoles[];
}

export interface StaffProfileUpdateParams {
    profile_id: number;
    first_name: string;
    last_name: string;
    email: string;
    roles: AssignableStaffRoles[];
}

export interface StaffManagementDrawerProps {
    profile?: StaffProfile;
    action: 'Add' | 'Update';
    handleClose: () => void;
    drawerOpen: boolean;
}

export interface CustomTagRenderProps extends TagProps {
    value: AssignableStaffRoles;
}

export type RolesSelect = {
    label: string;
    value: AssignableStaffRoles
}[];

export type StaffRolesMap = {
    [key in AssignableStaffRoles]: {
        color: string;
        name: string;
    };
}

export const staffRolesMap: StaffRolesMap = {
    'staff.business-development': {
        name: 'BizDev',
        color: 'purple',
    },
    'staff.finance': {
        name: 'Finance',
        color: 'green',
    },
    'staff.fleet': {
        name: 'Fleet',
        color: 'cyan',
    },
    'staff.human-resources': {
        name: 'HR',
        color: 'orange',
    },
    'staff.marketing': {
        name: 'Marketing',
        color: 'magenta',
    },
    'staff.member-care': {
        name: 'MCT',
        color: 'geekblue',
    },
}
